module.exports = __webpack_public_path__ + "img/txt_date@2x.9080f5e0.png";